import React, { useCallback, useRef } from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { Field, getIn } from 'formik';

const useStyles = makeStyles((theme) => ({
  viewer: {
    marginTop: theme.spacing(2),
  },
  input: {
    marginTop: theme.spacing(2),
  },
}));

const toBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const CustomFileField = (props: any) => {
  const classes = useStyles();
  const {
    form: { setFieldValue, values, errors, touched
    },
    field: { name },
  } = props;
  const formRef = useRef<any>();
  const handleOnChange = useCallback(
    async (event) => {
      try {
        const [file] = event.currentTarget.files;
        if (file) {
          const { name: filename } = file;
          const piece = await toBase64(file);
          let formFiles = getIn(values, name) || [];
          setFieldValue(name, [...formFiles, { piece, name: filename }]);
        }
        if (formRef && formRef.current) {
          formRef.current.value = '';
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    [values, setFieldValue, name, formRef]
  );

  const handleOnDelete = useCallback(
    (fileIndex) => {
      let formFiles = ((getIn(values, name) as any[]) || []).filter(
        (_, index) => index !== fileIndex
      );
      setFieldValue(name, formFiles);
    },
    [values, setFieldValue, name]
  );

  return (
    <div>
      <FormControl component="fieldset" className={props.className}>
        <FormLabel component="legend">{props.label}</FormLabel>
        {!props.disabled && (
          <input className={classes.input} type="file" onChange={handleOnChange} ref={formRef} />
        )}
      </FormControl>
      <div className={classes.viewer}>
        {((getIn(values, name) as any[]) || []).map((image, index) => (
          <div>
            <Link
              component="button"
              variant="body2"
              onClick={(event: any) => {
                event.preventDefault();
                props?.onFileSelect?.(image);
              }}
            >
              {image?.name}
            </Link>
            {!props.disabled && (
              <IconButton color="secondary" size="small" onClick={() => handleOnDelete(index)}>
                <DeleteIcon />
              </IconButton>
            )}
          </div>
        ))}
        {errors.fieldReportsDto?.attachedPieces && touched.fieldReportsDto && <div style={{ color: 'red' }}>{errors?.fieldReportsDto?.attachedPieces}</div>}
      </div>

    </div>
  );
};

const FIleField = (props: any) => <Field {...props} component={CustomFileField} />;

export default FIleField;
